import React from "react";
import { ViewMore } from "../../pages/SignedUpBusinesses";
import { useState } from "react";
import { BusinessController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";

const ViewMoreContainer = ({ closeModal, data, infoModal, setInfoModal, }) => {

    const [loading, setLoading] = useState(false);


    const onSubmit = async (values) => {


        setLoading(true);
        const payload = {
            business: data._id,
            status: values.status,
            reason: values.reason
        }

        const { status, errorMessage } = await BusinessController.updateBusinessStatus(payload)

        if (status === constant.Success) {
            setLoading(false);
            if (data.status === "INACTIVE") {
                MimaToastUtil.success({ message: 'Business approved' })
            } else if (data.status === "ACTIVE") {
                MimaToastUtil.error({ message: 'Business Suspended' })
            }
            return closeModal();
        }
        setLoading(false);
        MimaToastUtil.error({ message: errorMessage });
    }

    return (
        <ViewMore
            data={data}
            onSubmit={onSubmit}
            setInfoModal={setInfoModal}            
            closeModal={closeModal}
            infoModal={infoModal}    
            loading={loading}       
        />
    )
}
export default ViewMoreContainer;